/**
 * Internationalization strings for the chatbot
 * Supports English (default), French, and German
 */

import enStrings from './en.json';
import frStrings from './fr.json';
import deStrings from './de.json';

/**
 * English strings (default/fallback)
 */
export const EN_STRINGS = enStrings;

/**
 * French strings
 */
export const FR_STRINGS = frStrings;

/**
 * German strings
 */
export const DE_STRINGS = deStrings;

/**
 * All available translations
 */
export const TRANSLATIONS = {
    en: EN_STRINGS,
    fr: FR_STRINGS,
    de: DE_STRINGS
};

/**
 * Default language fallback
 */
export const DEFAULT_LANGUAGE = 'en';

/**
 * Format a string template with parameters
 * @param {string} template - String with {0}, {1}, etc. placeholders
 * @param {...any} args - Values to replace placeholders
 * @returns {string} Formatted string
 *
 * @example
 * formatString("Hello {0}, you have {1} messages", "John", 5)
 * // Returns: "Hello John, you have 5 messages"
 */
export function formatString(template, ...args) {
    if (!template || typeof template !== 'string') {
        return '';
    }

    return template.replace(/{(\d+)}/g, (match, index) => {
        const value = args[parseInt(index)];
        return value !== undefined && value !== null ? String(value) : match;
    });
}
